export default __webpack_public_path__ + "images/defect_map_upload-znHLS.png";